/* ===== Подключение компонентов React ===== */

/* ===== Подключение локальной Базы Данных ===== */
import AdvantageCards from "../../../data/cardsDb/advantageCards";

/* ===== Подключение локальных компонентов ===== */
import Card from "../../ui/Card/CardsSection";

/* ===== Подключение стилей ===== */
import s from "./Advantages.module.scss";


function Advantages() {
    return (
        <section className={s.advantages}>
            <div className={`container ${s.container}`}>
            <div className={s.title}>
                <h2>Преимущества работы с нами</h2>
            </div>
            <div className={s.cards}>
                <Card {...AdvantageCards} />
            </div>
            </div>
        </section>
    )
}

export default Advantages;